import LoginModal from "@/components/modals/LoginModal";
import EditorTasks from "@/components/video-editor-interface/EditorTasks";
import { SessionContext } from "@/context/SessionContext";
import { Box, Card, Text, Title, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconLock } from "@tabler/icons-react";
import React, {
	useContext,
	useEffect,
	useRef,
	useState,
} from "react";
import { Link } from "react-router-dom";

const VideoEditorInterface: React.FC = () => {
	const [showLoginModal, setShowLoginModal] = useState<boolean>(false);
	const [userHasAccess, setUserHasAccess] = useState<boolean>(false);

	const theme = useMantineTheme();
	const session = useContext(SessionContext);
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
	const fzMed = isMobile ? 18 : 24;

	const dashboardRef = useRef<HTMLDivElement>(null);

	if (!session) {
		return null;
	}

	useEffect(() => {
		if (session.user && session.user.isVideoEditor) {
			setUserHasAccess(true);
			setShowLoginModal(false);
		} else {
			setUserHasAccess(false);
			if (session.user == null) {
				setShowLoginModal(true);
			}
		}
	}, [session.user]);

	if (!userHasAccess) {
		return (
			<>
				<LoginModal showModal={showLoginModal} setShowModal={setShowLoginModal} />
				<Card p={20}>
					<IconLock size={48} color={theme.colors.red[6]} />
					<Text>You do not have permission to access this page.</Text>
					<Text>Please log into an account with access or <Link to="/">click here to navigate away</Link>.</Text>
				</Card>
			</>
		);
	}

	return (
		<Box
			ref={dashboardRef}
			w="100%"
			h="100%"
			style={{
				display: "grid",
				gridTemplateRows: "auto 1fr", // header, then the table area fills the rest
				overflow: "hidden",
				minHeight: 0,
			}}
		>
			{/* Header */}
			<Title
				p="xs"
				size={fzMed}
				c={theme.colors.blue[0]}
				ta="center"
			>
				Video Editing Tasks
			</Title>

			<Box w="98%" pb={15} h="100%" style={{ justifySelf: "center", overflow: "hidden", minHeight: 0, borderRadius: 16 }} bg={theme.colors.blue[8]}>
				<EditorTasks />
			</Box>
		</Box>
	);
};

export default VideoEditorInterface;
